/**
 * Ведомость доставки (`agent_attention`, CASH-CONTRACTS §6): запись, которая требует человека. Не факт чека и не сверка денег.
 * Разбор на границе: неизвестный вид не отбрасывается (показывается как есть), битая запись — ошибка ответа целиком.
 */
export interface OwnAttentionItem {
  id: number
  agentId: string
  operationId: string | null
  revision: number | null
  /** Вид (`card-money-without-receipt`, `in-doubt`, `agent-silent`, …); неизвестный остаётся строкой. */
  kind: string
  open: boolean
  code: string
  /** Текст службы — дословно. */
  text: string
  createdAt: string
  closedAt: string | null
  closedBy: string | null
}

const requiredString = (value: unknown, field: string): string => {
  if (typeof value !== 'string') throw new Error(`В ведомости доставки нет поля «${field}».`)
  return value
}
const optionalString = (value: unknown): string | null => (typeof value === 'string' && value !== '' ? value : null)

export function decodeOwnAttention(raw: unknown): readonly OwnAttentionItem[] {
  const items = (raw as { items?: unknown } | null)?.items
  if (!Array.isArray(items)) throw new Error('Ведомость доставки вернулась в неожиданном виде.')
  return items.map((entry: unknown) => {
    if (typeof entry !== 'object' || entry === null) throw new Error('Ведомость доставки содержит неразборчивую запись.')
    const value = entry as Record<string, unknown>
    if (typeof value.id !== 'number') throw new Error('В записи ведомости доставки нет номера.')
    return {
      id: value.id,
      agentId: requiredString(value.agentId, 'agentId'),
      operationId: optionalString(value.operationId),
      revision: typeof value.revision === 'number' ? value.revision : null,
      kind: requiredString(value.kind, 'kind'),
      open: value.state === 'open',
      code: requiredString(value.code, 'code'),
      text: requiredString(value.text, 'text'),
      createdAt: requiredString(value.createdAt, 'createdAt'),
      closedAt: optionalString(value.closedAt),
      closedBy: optionalString(value.closedBy),
    }
  })
}
